import React, { useState, useEffect } from 'react';
import ReactDOM from 'react-dom';

import App from 'App';

import ApiClientItemConfigs from './ApiClientItemConfigs';
import ApiClientItemDetails from './ApiClientItemDetails';

export default function ApiClientItemIndex(props) {
    const [app, setApp] = useState(null);
    const [fetching, setFetching] = useState(false);

    useEffect(() => {
        fetchApp();
    }, []);

    const fetchApp = () => {
        setFetching(true);

        axios
            .get(props.fetchUrl)
            .then((res) => {
                setApp(res.data.app);
            })
            .catch((e) => {
                console.log(e.response);
            })
            .finally(() => {
                setFetching(false);
            });
    };

    return (
        <div>
            <div className="tw-mb-2">
                <a href={props.indexUrl}>App List</a>
            </div>

            <ul className="nav nav-tabs" id="integration-app-update" role="tablist">
                <li className="nav-item" role="presentation">
                    <button
                        className="nav-link active bg-transparent font-weight-bold"
                        id="details_tab"
                        data-toggle="tab"
                        data-target="#app_details"
                        type="button"
                        role="tab"
                        aria-controls="app_details"
                        aria-selected="true"
                    >
                        {$t('App Details')}
                    </button>
                </li>
                <li className="nav-item" role="presentation">
                    <button
                        className="nav-link bg-transparent font-weight-bold"
                        id="config_tab"
                        data-toggle="tab"
                        data-target="#app_config"
                        type="button"
                        role="tab"
                        aria-controls="app_config"
                    >
                        {$t('Configuration')}
                    </button>
                </li>
            </ul>

            <div className="tab-content" id="integration-app-update-content">
                <div className="tab-pane fade show active border-0" id="app_details" role="tabpanel" aria-labelledby="details_tab">
                    <ApiClientItemDetails
                        app={app}
                        updateDetailsUrl={props.updateDetailsUrl}
                        deleteUrl={props.deleteUrl}
                        fetchApp={fetchApp}
                        listUrl={props.indexUrl}
                    />
                </div>
                <div className="tab-pane fade show border-0" id="app_config" role="tabpanel" aria-labelledby="config_tab">
                    <ApiClientItemConfigs
                        app={app}
                        updateConfigsUrl={props.updateConfigsUrl}
                        fetchApp={fetchApp}
                        generateSecretUrl={props.generateSecretUrl}
                        revokeSecretUrl={props.revokeSecretUrl}
                    />
                </div>
            </div>
        </div>
    );
}

if (document.getElementById('ApiClientsItem')) {
    const rootEl = document.getElementById('ApiClientsItem');
    ReactDOM.render(
        <App>
            <ApiClientItemIndex
                fetchUrl={itemUrl}
                updateDetailsUrl={updateDetailsUrl}
                updateConfigsUrl={updateConfigsUrl}
                deleteUrl={deleteUrl}
                indexUrl={indexUrl}
                generateSecretUrl={generateSecretUrl}
                revokeSecretUrl={revokeSecretUrl}
                categories={categories}
                types={types}
                defaultCategory={defaultCategory}
                defaultType={defaultType}
            />
        </App>,
        rootEl,
    );
}
